import {getField, updateField} from "vuex-map-fields";
import * as actions from "./actions";
import mutations from "./mutations";

export default {
    namespaced: true,
    state: {
        error: "",
        isLoading: false,
        form: {
            screens: {},
            domain: null,
            gtag: null,
            gtag_url: null
        },
        user: {
            first_name: '',
            last_name: '',
            authenticated: false,
            email: false
        },
        site: {
            name: '',
            email: '',
            logo: ''
        },
        settings: {
          "features": {
            "progressbar" : true
          },
          "hidden_fields": {
            "key": "value"
          },
          "theme" : {
            "colors" : {
              "primary" : "primary",
              "secondary" : "secondary"
            },
              dark: false,
              screen:{
                  title: true,
                  title_main: true,
                  text: true
              },
              input : {
                  label: false,
                  sublabel: true,
                  description: true,
                  dense: true,
                  filled: false,
                  outlined: true,
                  standout: false,
                  borderless: false,
                  rounded: false,
                  square: false
              },
              button : {
                  flat: false,
                  rounded: false,
                  round: false,
                  outline: false,
                  push: false,
                  unelevated: false,
                  noCaps: false,
                  glossy: false,
                  cs: false,
                  colors : {
                      primary : null,
                      border : null,
                      hover: null,
                      hover_border: null,
                      text: null,
                      text_hover: null,
                      active: null
                  },
                  size: "md"
              },
              next : {
                  cs: false,
                  colors : {
                      primary : null,
                      border : null,
                      hover: null,
                      hover_border: null,
                      text: null,
                      text_hover: null,
                  },
                  size: "md"
              },
              back : {
                  cs: false,
                  colors : {
                      primary : null,
                      border : null,
                      hover: null,
                      hover_border: null,
                      text: null,
                      text_hover: null,
                  },
                  size: "md"
              }
          }
        },
        fieldsById : {}
    },
    actions,
    getters: {
        getField,
    },
    mutations: {
        updateField,
        ...mutations,
    },
};
